export function getGameMinute(timeInSeconds) {
    return `${Math.floor(timeInSeconds / 60)}`;
}
//# sourceMappingURL=TimeHelpers.js.map